import { getFileAttributes } from '../..';
import { getPrimaryErrorReason } from '../../../errors';
export var createFailedPreviewDownloadButtonClickedEvent = function createFailedPreviewDownloadButtonClickedEvent(fileState, error) {
  var _getFileAttributes = getFileAttributes(fileState),
    fileId = _getFileAttributes.fileId,
    fileMediatype = _getFileAttributes.fileMediatype,
    fileMimetype = _getFileAttributes.fileMimetype,
    fileSize = _getFileAttributes.fileSize;
  return {
    eventType: 'ui',
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'failedPreviewDownloadButton',
    attributes: {
      failReason: getPrimaryErrorReason(error),
      fileAttributes: {
        fileId: fileId,
        fileMediatype: fileMediatype,
        fileMimetype: fileMimetype,
        fileSize: fileSize
      },
      fileProcessingStatus: fileState.status
    }
  };
};